import _ from 'lodash';

/**
 * Determines if an event uses the legacy proposal system
 *
 * Legacy proposals (v1):
 * - Hardcoded page IDs (photos, videos, sharing, etc.)
 * - Text content from brandingSettings
 * - Print templates in the old structure
 *
 * New proposals (v1.5):
 * - proposalConfig.sections with custom content
 * - Dynamic section ordering
 * - New pricing structure
 *
 * @param {object} event - Full event object
 * @returns {boolean} - True if legacy (v1), false if new system (v1.5+)
 */
export const isLegacyProposal = (event) => {
  // Check for explicit version field (always a string)
  const version = _.get(event, 'proposalConfig.version');

  // If no version, default to legacy
  if (!version) {
    return true;
  }

  // v1.5 or higher = new system
  // String comparison works correctly for version numbers like "1.5", "2", "2.0"
  if (version >= '1.5') {
    return false;
  }

  // Default to legacy for backwards compatibility
  return true;
};
